export default __webpack_public_path__ + "static/imageSixthSection-76b544b74956704f4cfe6dcb8bd2b095.svg";